<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("templates_list") }}</template>

			<template slot="actions">
				<j-button
					size="small"
					class="mr2"
					type="secondary"
					@click="$router.push({ name: 'TemplateAssets' })"
					>{{ $t("manage_template_assets") }}</j-button
				>

				<v-popover
					placement="bottom-end"
					popoverClass="xs-12 r2"
					popoverArrowClass="xs-0"
					popoverInnerClass="xs-12 r2 bg5 b1 bc7"
					popoverWrapperClass="xs-12"
				>
					<j-button size="small">
						{{ $t("create_template") }}
						<crm-icon name="down" class="ml1" color="c5" size="small" />
					</j-button>
					<template slot="popover">
						<div
							class="xs-12 p3 fw7 c1 cu2 bb1 bc7"
							@click="$router.push({ name: 'PdfTemplatesCreate' })"
							v-close-popover
						>
							{{ $t("pdf_template") }}
						</div>
						<div
							class="xs-12 bb1 bc7 p3 fw7 cu2 c1"
							@click="$router.push({ name: 'EmailTemplateCreate' })"
							v-close-popover
						>
							{{ $t("email_template") }}
						</div>
						<div
							class="xs-12 p3 fw7 cu2 c1 bb1 bc7"
							@click="$modal.show('createDynamicTemplate')"
							v-close-popover
						>
							{{ $t("dynamic_template") }}
						</div>
						<div
							class="xs-12 p3 fw7 cu2 c1 bb1 bc7"
							@click="$modal.show('createFunctionTemplate')"
							v-close-popover
						>
							{{ $t("function_template") }}
						</div>
						<div
							class="xs-12 p3 fw7 cu2 c1"
							@click="$modal.show('createNotificationTemplate')"
							v-close-popover
						>
							{{ $t("notification_template") }}
						</div>
					</template>
				</v-popover>
			</template>
		</core-layout-headline-and-actions>

		<div class="xs-12 flex wrap">
			<div class="templates xs-12 wrap">
				<!-- TODO: temporarily disabled -->
				<!-- <div class="flex xs-12 pb4 xs-middle xs-between">
					<div class="xs-6">
						<j-base-input-search :value="searchTerm" @input="fetchTemplates" />
					</div>
				</div>-->

				<j-base-multi-select
					:placeholder="$t('filter')"
					class="mb2"
					:options="templateOptions"
					:value="templateWhere"
					@input="handleFilter"
				/>

				<div class="xs-12">
					<j-card class="bg5">
						<j-data-table
							:header="header"
							:list="computedList"
							:sortable="false"
							:isLoading="isLoading"
							@sort="onSort($event)"
						>
							<template slot="list" slot-scope="{ item }">
								<td v-for="(column, i) in header" :key="i">
									<template>
										<!-- Name -->
										<template v-if="column.field === 'name'">
											<router-link :to="decideToLink(item)">{{
												item.name
											}}</router-link>
										</template>

										<template
											v-else-if="
												column.field === 'createdAt' ||
													column.field === 'lastModifiedAt'
											"
											>{{ toDateFormat(item[column.field]) }}</template
										>

										<template v-else-if="column.field === 'actions'">
											<div class="xs flex xs-right">
												<!-- TODO: delete  -->
												<crm-icon
													color="cError"
													name="delete"
													@click.native="
														() => {
															$modal.show('j-dialog')
															selectedTemplateId = item.id
														}
													"
												/>
											</div>
										</template>
										<template v-else>{{ item[column.field] }}</template>
									</template>
								</td>
							</template>
							<template slot="empty">{{ $t("errors.no_data") }}</template>
						</j-data-table>
					</j-card>
				</div>
			</div>
		</div>

		<j-dialog
			:title="$t('delete_template')"
			type="delete"
			@confirm="deleteTemplate(selectedTemplateId)"
			>{{ $t("errors.are_you_sure_you_want_to_delete_template") }}</j-dialog
		>

		<core-modal
			name="createDynamicTemplate"
			:headline="$t('create_dynamic_template')"
		>
			<dynamic-template-create
				@created:dynamicTemplate="afterCreateTemplate('createDynamicTemplate')"
			/>
		</core-modal>

		<core-modal
			name="createFunctionTemplate"
			:headline="$t('create_function_template')"
		>
			<function-template-create
				@created:functionTemplate="
					afterCreateTemplate('createFunctionTemplate')
				"
			/>
		</core-modal>

		<core-modal
			name="createNotificationTemplate"
			:headline="$t('create_notification_template')"
		>
			<notification-template-create
				@created:notificationTemplate="
					afterCreateTemplate('createNotificationTemplate')
				"
			/>
		</core-modal>
	</core-layout-content>
</template>

<script>
import dayjs from "dayjs"
import CrmIcon from "@/components/CrmIcon"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CoreModal from "@/modules/core/components/CoreModal.vue"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JDialog from "@/components/JDialog/"
import JBaseMultiSelect from "@/components/JBaseMultiSelect/"

import DynamicTemplateCreate from "../components/DynamicTemplate/DynamicTemplateCreate"
import FunctionTemplateCreate from "../components/FunctionTemplate/FunctionTemplateCreate"
import NotificationTemplateCreate from "../components/NotificationTemplate/NotificationTemplateCreate"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CrmIcon,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		JButton,
		JCard,
		JDataTable,
		JDialog,
		CoreModal,
		JBaseMultiSelect,

		DynamicTemplateCreate,
		FunctionTemplateCreate,
		NotificationTemplateCreate
	},
	data() {
		return {
			list: [],
			limit: 50,
			skip: 0,
			sortOrder: "desc",
			sort: {
				fieldName: "lastModifiedAt"
			},
			searchTerm: null,
			tab: "pdfDrawing",
			selectedTemplateId: null,
			dropdownOptions: [
				{ name: "pdf", event: "createPdf" },
				{ name: "email", event: "createEmail" }
			],
			isLoading: false,
			templateOptions: [
				{ name: this.$t("pdf_drawing"), value: "pdfDrawing" },
				{ name: this.$t("email_mjml"), value: "emailMjml" },
				{ name: this.$t("wkhtml_to_pdf"), value: "wkhtmltopdf" },
				{ name: this.$t("clause_html"), value: "clauseHtml" },
				{ name: this.$t("dynamic"), value: "dynamic" },
				{ name: this.$t("function"), value: "function" },
				{ name: this.$t("notification"), value: "notification" }
			],
			templateWhere: null
		}
	},
	methods: {
		toDateFormat(value) {
			return dayjs(value).format(this.$store.state.settings.dateTimeFormat)
		},

		async fetchTemplates() {
			const query = gql`
				query fetchTemplates($where: templateWhereInput, $sort: sortInput) {
					templates(where: $where, sort: $sort) {
						totalCount
						list {
							id
							name
							__typename
							createdAt
							lastModifiedAt
						}
					}
				}
			`

			let variables = {
				// where: { or: this.computedWhere?.map(item => ({ type: item })) },
				where: this.computedWhere,
				sort: { fieldName: "createdAt", type: "desc" }
			}

			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			this.list = res?.data?.templates?.list
		},

		onTabChange(value) {
			this.tab = value
			this.fetchTemplates()
		},

		async deleteTemplate(id) {
			/* Delete l10n if it is a notification template*/
			if (
				this.list?.find(t => t.id === id)?.__typename === "notificationTemplate"
			) {
				const deleteAllL10n = gql`
					mutation deleteAllL10n($key: String!) {
						deleteAllL10n(key: $key) {
							errors
							status
						}
					}
				`
				const variables = {
					key: `templates-${id}-html`
				}
				const l10nRes = await api({ query: deleteAllL10n, variables })
				if (l10nRes.errors) this.$store.dispatch("showError", l10nRes.errors)
			}

			/* delete template */
			const query = gql`
				mutation deleteTemplate($templateId: String!) {
					deleteTemplate(templateId: $templateId) {
						status
						errors
					}
				}
			`
			const res = await api({ query: query, variables: { templateId: id } })
			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("template_deleted")
					}
				})

			this.fetchTemplates()
		},

		afterCreateTemplate(modalName) {
			this.$modal.hide(modalName)
			this.fetchTemplates()
		},

		decideToLink(obj) {
			const { __typename, id } = obj

			const routes = [
				{ type: "pdfDrawingTemplate", value: "PdfTemplatesUpdate" },
				{ type: "wkhtmltopdfTemplate", value: "PdfTemplatesUpdate" },
				{ type: "emailMjmlTemplate", value: "EmailTemplateUpdate" },
				{ type: "dynamicTemplate", value: "DynamicTemplateUpdate" },
				{ type: "functionTemplate", value: "FunctionTemplateUpdate" },
				{ type: "notificationTemplate", value: "NotificationTemplatesUpdate" }
			]

			return {
				name: routes?.find(route => route.type === __typename)?.value,
				params: {
					id
				}
			}
		},

		handleFilter(payload) {
			this.$store.commit("templates/SET_FILTER_WHERE", {
				or: payload?.map(item => ({ type: item }))
			})
		}
	},

	computed: {
		computedList() {
			return this.list
		},
		computedTab() {
			return this.tab
		},
		header() {
			return [
				{
					field: "name",
					text: this.$t("name")
				},
				{
					field: "__typename",
					text: this.$t("type")
				},
				{
					field: "createdAt",
					text: this.$t("created")
				},
				{
					field: "lastModifiedAt",
					text: this.$t("updated")
				},
				{
					field: "actions",
					text: this.$t("actions")
				}
			]
		},
		computedWhere() {
			return this?.$store?.state?.templates?.filter?.where
		}
	},

	watch: {
		computedWhere: {
			handler() {
				this.templateWhere = this.computedWhere
					? this.computedWhere?.or?.map(item => item.type)
					: null
				this.fetchTemplates()
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
